(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOWebapi"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOWebapi", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/top-trading-signals/render"] = factory(require("VueDemi"), require("FEGOWebapi"), require("FEGORender"));
	else
		root["/fego/component/top-trading-signals/render"] = factory(root["VueDemi"], root["FEGOWebapi"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__5322__) => {
return 